import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";

import React, { useEffect, useState } from "react";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import AtmPayRollPopUp from "../AtmPayRollPopUp/AtmPayRollPopUp";
import UploadFilePopUp_New from "../../../../../ReusableComponents/UploadFile/UploadFileNew";

export default function ListAtmPayroll({
  token,
  titles = [],
  // list = [],
  loading,
  // updateData,
}) {
  // useEffect(() => {
  //   setFiltered(list);
  // }, [list]);
  const dispatch = useDispatch();

  //filter
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const [filter, setFiltered] = React.useState([]);

  const [Popup, setPopUp] = useState(false);
  const [selectedPopup, setSelectedPopup] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);

  const getDataByFilter = async () => {
    const reqObj = {
      Company: selectVisaProvider,
      client: selectedStatus,
    };
    try {
      const response = await nodeinstance.post(
        `/atm-payroll/getEmployeesByFilter`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setFiltered(response.data.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };
  // const {
  //   NoDataFound,
  //   Pagination,
  //   PaginationIndex,
  //   Search,
  //   CountPerPage,
  //   currentList,
  // } = useSearchPagination(filter || []);

  const apiCall = () => {
    // updateData("123654");
    if (selectVisaProvider != "" || selectedStatus != "") {
      getDataByFilter();
    }
    setCheckedItems({});
    setItemList([]);
  };
  const downloadFile = async () => {
    if (filter.length <= 0) {
      dispatch(
        setAppError({
          msg: "No data to download.",
          color: "success",
        })
      );
      return;
    }
    setDownloadLoading(true);
    try {
      const reqObj = {
        Company: selectVisaProvider,
        client: selectedStatus,
      };
      const response = await nodeinstance.post(
        `/atm-payroll/downloadCategory`,
        reqObj,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Atm_Payroll`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const [checkedItems, setCheckedItems] = React.useState({});
  const [itmeList, setItemList] = React.useState([]);

  // Handle individual checkbox change
  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;

    // Update checkedItems state
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Mark as checked
      } else {
        delete nextState[employee_id]; // Unmark (remove)
      }
      return nextState;
    });

    // Update itemList state
    setItemList((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list); // Add selected item
      }
      return updatedList;
    });
  };

  // Handle "Select All" checkbox
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Select all checkboxes
      const allCheckedItems = {};
      const allItemList = [];

      filter.forEach((employee) => {
        allCheckedItems[employee.employee_id] = true;
        allItemList.push(employee); // Assuming each employee has a 'list' field
      });

      setCheckedItems(allCheckedItems);
      setItemList(allItemList);
    } else {
      // Deselect all checkboxes
      setCheckedItems({});
      setItemList([]);
    }
  };

  // Check if all employees are selected
  const isAllSelected = Object.keys(checkedItems).length === filter.length;

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([employee_id, isChecked]) => isChecked)
      .map(([employee_id]) => employee_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setSelectedPopup(true);
    }
  };

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    console.log("Selected Client:", clientStatus);
    setSelectedStatus(clientStatus);

    // const filteredData = list.filter((indexData) => {
    //   if (clientStatus && selectVisaProvider) {
    //     return (
    //       indexData.client === clientStatus &&
    //       indexData.visa_provider === selectVisaProvider
    //     );
    //   } else if (clientStatus) {
    //     return indexData.client === clientStatus;
    //   } else if (selectVisaProvider) {
    //     return indexData.visa_provider === selectVisaProvider;
    //   } else {
    //     return true; // No filters applied, show all data
    //   }
    // });

    // setFiltered(filteredData);
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Visa Provider:", visaProvider);
    setSelectVisaProvider(visaProvider);

    // const filteredData = list.filter((indexData) => {
    //   if (selectedStatus && visaProvider) {
    //     return (
    //       indexData.client === selectedStatus &&
    //       indexData.visa_provider === visaProvider
    //     );
    //   } else if (selectedStatus) {
    //     return indexData.client === selectedStatus;
    //   } else if (visaProvider) {
    //     return indexData.visa_provider === visaProvider;
    //   } else {
    //     return true; // No filters applied, show all data
    //   }
    // });

    // setFiltered(filteredData);
  };

  console.log(
    "ATM data to be seen in the page",
    selectVisaProvider,
    selectedStatus
  );

  useEffect(() => {
    if (selectVisaProvider != "" || selectedStatus != "") {
      console.log("trigger.........");
      getDataByFilter();
      return;
    } else {
      setFiltered([]);
    }
  }, [selectVisaProvider, selectedStatus]);
  console.log("log to be printed in the console ATM-PAYROLL");
  return (
    <>
      <div className="flex flex-wrap  gap-2 w-full items-center  flex-row-reverse">
        <button
          className="p-2 h-10 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center"
          onClick={() => setPopUp(true)}
        >
          <p>Upload PayRoll Status</p>
        </button>
        <button
          className="p-2 px-4 h-10 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center "
          onClick={() => downloadFile()}
          // disabled={downloadLoading || list?.isLoading}
        >
          <p>Download</p>
          {downloadLoading && <CgSpinner className="animate-spin" />}
        </button>
        <button
          className="p-2 px-4 h-10 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center "
          onClick={() => popOpen()}
        >
          Update Payroll Category for selected Employees
        </button>

        <FilterDropDown
          onChange={visaProviderFilter}
          title={"Visa Provider"}
          url={`/sadaad/visa-providers/`}
          token={token}
          selectedStatus={selectVisaProvider}
        />
        <FilterDropDown
          onChange={onChangeValue}
          title={"Client"}
          url={`/sadaad/clients`}
          token={token}
          selectedStatus={selectedStatus}
        />
        {/* <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        /> */}
      </div>
      {/* <CountPerPage /> */}
      <div className="relative bg-white mt-4">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 bg-white min-w-[1650px]">
            <div className="grid grid-cols-table-atm-payroll gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t === "Action" ? (
                    <div>
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                        disabled={!selectVisaProvider || !selectedStatus}
                      />
                    </div>
                  ) : (
                    t
                  )}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-atm-payroll gap-5 p-6 bg-white text-center">
            {/* {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />} */}
            {filter.map((list, index) => (
              <React.Fragment key={index}>
                {/* <PaginationIndex index={index} /> */}
                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.employee_id || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.name || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.client || ""}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.visa_provider || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.iqama_number || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.mobile_number || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.payroll_category || "-"}
                  />
                </p>
                <div>
                  <input
                    type="checkbox"
                    checked={!!checkedItems[list.employee_id]}
                    onChange={(e) =>
                      handleCheckboxChange(e, list.employee_id, list)
                    }
                    disabled={!selectVisaProvider || !selectedStatus}
                  />
                </div>
                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-full`}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      {/* <Pagination /> */}

      {Popup ? (
        <UploadFilePopUp_New
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload ATM/PAYROLL"}
          url={"/atm-payroll/uploadCategory"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
      {selectedPopup ? (
        <AtmPayRollPopUp
          list={itmeList}
          PopUp={selectedPopup}
          setPopUp={setSelectedPopup}
          title={"UPDATE PAYROLL CATEGORY"}
          url={"apiUrl"}
          callBack={apiCall}
          token={token}
          setCheckedItems={setCheckedItems}
          setItemList={setItemList}
        />
      ) : (
        ""
      )}
    </>
  );
}
